<div class="teaser-container mb-2">
  @if (teasers?.length) {
    @for (teaser of teasers | discoverSlide: slide : itemsPerSlide; track teaser.id) {
      <div class="card mb-2" (click)="openDetails.emit(teaser.id)">
        <div class="card-inner">
          <h5 class="mb-2">{{ teaser.title }}</h5>
          <div>{{ teaser.description }}</div>
        </div>
      </div>
    }
  }
</div>

@if (teasers?.length > itemsPerSlide) {
  <discover-paging [itemsPerSlide]="itemsPerSlide" [size]="teasers.length" (slideChange)="slide = $event" />
}
